module.exports = ":host .m-fake-select {\n  padding-left: 0; }\n"